import React from 'react';
import PrivacyPolicyText from "../components/PrivacyPolicyText";
import Breadcrumbs from "../components/Breadcrumbs";

const PrivacyPolicy = () => {
    return (
        <div>
            <Breadcrumbs/>
            <PrivacyPolicyText/>
        </div>
    );
};

export default PrivacyPolicy;